









import {Vue, Component, Prop} from "vue-property-decorator";

@Component
export default class BannerLink extends Vue {
    @Prop({ default: 'leftViewersPanelBanner' }) type: string;
    @Prop({ default: null }) outsideImageUrl: string | null;

    get banner() {
        const banners = this.$store.getters['events/selectedEventViewParam']('banners', {});
        return this.type in banners ? banners[this.type] : null;
    }

    get hasLink() {
        return !!(this.banner?.schemaId || this.banner?.schemaId && this.banner?.elementId) && !this.outsideImageUrl;
    }

    get eventId(): string {
        return this.$store.state.events?.selected;
    }

    get image() {
        return this.outsideImageUrl || this.banner?.imageUrl
    }

    get url() {
        const banner = this.banner;
        return {
            name: banner.elementId ? 'Partner' : 'Partners',
            params: {
                backend: this.$route.params.backend,
                eventId: this.eventId ?? '',
                schemaId: banner.schemaId ?? '',
                id: banner?.elementId ?? ''
            }
        }
    }
}
